import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "getActionTagName", "getActionAttributes", "getActionDisabled", "getActionLabel", "getActionOnClick", "getActionRef", "getActionIconLeft", "getActionIconRight", "getActionView", "title", "children", "className", "id", "subTitle", "portalProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cnBem } from '@carnica/utils';
import React, { forwardRef } from 'react';
import { Modal } from "../Modal";
import styles from "./styles.pcss";
import { composePreparedProps, getActionParams } from "./utils";
import { Title } from "../Title";
import { Button } from "../Button";
var cnDialog = cnBem('dialog', styles);
var getTitleId = function getTitleId(id) {
  if (id) {
    return "dialog-title-".concat(id);
  }
  return 'dialog-title';
};
var DialogRender = function DialogRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    actions = _composePreparedProps.actions,
    getActionTagName = _composePreparedProps.getActionTagName,
    getActionAttributes = _composePreparedProps.getActionAttributes,
    getActionDisabled = _composePreparedProps.getActionDisabled,
    getActionLabel = _composePreparedProps.getActionLabel,
    getActionOnClick = _composePreparedProps.getActionOnClick,
    getActionRef = _composePreparedProps.getActionRef,
    getActionIconLeft = _composePreparedProps.getActionIconLeft,
    getActionIconRight = _composePreparedProps.getActionIconRight,
    getActionView = _composePreparedProps.getActionView,
    title = _composePreparedProps.title,
    children = _composePreparedProps.children,
    className = _composePreparedProps.className,
    id = _composePreparedProps.id,
    subTitle = _composePreparedProps.subTitle,
    portalProps = _composePreparedProps.portalProps,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var getAction = function getAction(action) {
    return getActionParams({
      action: action,
      getActionTagName: getActionTagName,
      getActionAttributes: getActionAttributes,
      getActionDisabled: getActionDisabled,
      getActionLabel: getActionLabel,
      getActionOnClick: getActionOnClick,
      getActionIconLeft: getActionIconLeft,
      getActionIconRight: getActionIconRight,
      getActionRef: getActionRef,
      getActionView: getActionView
    });
  };
  return /*#__PURE__*/React.createElement(Modal, _extends({}, otherProps, {
    className: cnDialog(null, [className]),
    portalProps: _objectSpread(_objectSpread({}, portalProps || {}), {}, {
      'aria-labelledby': getTitleId(id)
    }),
    ref: ref,
    size: "s",
    "data-t-id": "components-Dialog"
  }), title && /*#__PURE__*/React.createElement(Title, {
    align: "left",
    className: cnDialog('title'),
    id: getTitleId(id),
    size: "m",
    subTitle: subTitle,
    title: title
  }), children, actions && /*#__PURE__*/React.createElement("div", {
    className: cnDialog('actions')
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, getAction(action), {
      key: cnDialog('action', {
        index: index
      }),
      mode: "default",
      size: "l",
      width: "full"
    }));
  })));
};
export var Dialog = /*#__PURE__*/forwardRef(DialogRender);